type ErrorWithMessage = {
  message: string;
};

export function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return Boolean(
    error && Object.prototype.hasOwnProperty.call(error, 'message')
  );
}
